import { combineReducers } from 'redux';
import type { IReportRequestModalState } from './ReportModalSlice';
import { reportModalSlice } from './ReportModalSlice';
import type { IPageState } from './ReportsPageSlice';
import { reportsPageSlice } from './ReportsPageSlice';
import type { IReportDateRangeModalState } from './ReportDateRangeModalSlice';
import { reportDateRangeModalSlice } from './ReportDateRangeModalSlice';

export interface IReportsPageState {
	pageState: IPageState;
	reportRequestModalState: IReportRequestModalState;
	reportDateRangeModalState: IReportDateRangeModalState;
}

export const reducer = combineReducers<IReportsPageState>({
	pageState: reportsPageSlice.reducer,
	reportRequestModalState: reportModalSlice.reducer,
	reportDateRangeModalState: reportDateRangeModalSlice.reducer,
});
